import React from "react";
import { Img } from "../../Img";
export const ThreeImagesCardComponent = ({ imageUrl, imageAlt, comment, title }) => (React.createElement("div", { className: "threeImagesCardComponent" },
    React.createElement("div", { className: "threeImagesCardComponent__imageWrapper" },
        React.createElement(Img, { loading: "eager", src: imageUrl, alt: imageAlt })),
    React.createElement("h4", null, title),
    React.createElement("p", null, comment)));
